// extracted by mini-css-extract-plugin
export default {"headerIcon":"SessionAttendees_headerIcon__0G7lL"};